import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Sayfa içi geçişlerde (ör. ürün detayında önceki/sonraki ürün) kaydırma
    // konumu korunmak istenirse navigate state'inde preserveScroll gönderilir.
    if (location.state?.preserveScroll) {
      return;
    }
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}
